

// import React from 'react';
// import HighlightText from '../data/HighlightText';

// const About = () => {
//   return (
//     <div className='w-full min-h-screen bg-[#0a192f] text-white flex items-center justify-center pt-[85px] px-4'>
//       {/* Content Wrapper */}
//       <div className='mx-auto w-full max-w-screen-lg'>
//         {/* Heading */}
//         <h1 className='text-3xl lg:text-4xl font-bold mb-6 text-center'>
//           <HighlightText text="About" />
//         </h1>

//         {/* Grid layout for two main divs */}
//         <div className='flex flex-col lg:flex-row gap-8'>
//           {/* Left column */}
//           <div className='lg:w-1/2 w-full'>
//             <p className='text-base lg:text-xl mb-4'>
//               Hi! I'm Rakesh Gupta, a B.Tech graduate in Information Technology from Rajkiya Engineering College Bijnor.
//               <br />
//               <HighlightText text="With hands-on experience in the MERN stack (MongoDB, Express.js, React.js, Node.js) and a solid foundation in HTML, CSS, JavaScript, MySQL, and Data Structures & Algorithms (C++)," />
//               <br />
//               I am passionate about software development. I gained practical experience through internships at CodSoft Private Limited and Pairtech Company, where I worked on developing web applications and utilizing modern technologies. I completed an 8-month DSA course on Coding Ninjas and a 10-month MERN stack BootCamp through the Code Help platform by Love Babbar, and have developed 10 MERN projects. I'm a quick learner, a dedicated team player, and enthusiastic about continuously expanding my skills and building innovative web products.
//             </p>
//           </div>

//           {/* Right column */}
//           <div className='lg:w-1/2 w-full'>
//             {/* Placeholder for future content, such as an image or additional text */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default About;

import React from 'react';
import HighlightText from '../data/HighlightText';

const About = () => {
  return (
    <div className='w-full min-h-screen bg-[#0a192f] text-white flex items-center justify-center pt-[85px] px-4'>
      {/* Content Wrapper */}
      <div className='mx-auto w-full max-w-screen-md text-center'>
        {/* Heading */}
        <h1 className='text-3xl lg:text-4xl font-bold mb-6'>
          <HighlightText text="About" />
        </h1>

        {/* Centered Content Section */}
        <div className='text-base lg:text-xl'>
          <p className='mb-4'>
            Hi! I'm Rakesh Gupta, a B.Tech graduate in Information Technology from Rajkiya Engineering College Bijnor.
            <br />
            <HighlightText text="With hands-on experience in the MERN stack (MongoDB, Express.js, React.js, Node.js) and a solid foundation in HTML, CSS, JavaScript, MySQL, and Data Structures & Algorithms (C++)," />
            <br />
            I am passionate about software development. I gained practical experience through internships at CodSoft Private Limited and Pairtech Company, where I worked on developing web applications and utilizing modern technologies. I completed an 8-month DSA course on Coding Ninjas and a 10-month MERN stack BootCamp through the Code Help platform by Love Babbar, and have developed 10 MERN projects. I'm a quick learner, a dedicated team player, and enthusiastic about continuously expanding my skills and building innovative web products.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;

